export enum ModalTemplate {
  INSPIRATIONS = 'Impulse & Credits',
  LEGAL_NOTICE = 'Impressum',
  PRIVACY_POLICY = 'Datenschutzerklärung',
}
